import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import SoftButton from "components/SoftButton";

const DialogWrapper = ({ open, closeDialog, title, children }) => {
  const { t } = useTranslation("flowDesigner");
  const [dialogTitle, setDialogTitle] = useState("");

  useEffect(() => {
    setDialogTitle(title || t("common.select_flow"));
  }, [open]);

  return (
    <Dialog
      className="designer-flow-selection-dialog"
      open={open}
      fullWidth={true}
      maxWidth={false}
      onClose={closeDialog}
      aria-labelledby="componentSelectionDialogTitle"
    >
      <DialogTitle id="componentSelectionDialogTitle">{dialogTitle}</DialogTitle>
      <DialogContent className="designer-flow-selection-content">
        {children}
      </DialogContent>
      <DialogActions>
        <SoftButton color="primary" variant="outlined" onClick={closeDialog}>{t("buttons.cancel")}</SoftButton>
      </DialogActions>
    </Dialog>
  )
}

export default DialogWrapper;
